/**
 * @generated SignedSource<<6f62d718ef04f9d6e92ebd4400371aea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePayPalClient_viewer$data = {
  readonly clientToken: {
    readonly value: string | null;
  } | null;
  readonly " $fragmentType": "usePayPalClient_viewer";
};
export type usePayPalClient_viewer$key = {
  readonly " $data"?: usePayPalClient_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePayPalClient_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePayPalClient_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Token",
      "kind": "LinkedField",
      "name": "clientToken",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5652b487d182fd2ef014a65421123784";

export default node;
